import script from "./BoardListView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardListView.vue?vue&type=script&setup=true&lang=js"

import "./BoardListView.vue?vue&type=style&index=0&id=28537c38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28537c38"]])

export default __exports__